import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
import { getToken } from '@/http/tools'
Vue.use(Router)

const router = new Router({
  routes: routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta && record.meta.requiresAuth)
  if (requiresAuth && !getToken()) {
    next({
      name: 'login',
      query: { redirect: to.fullPath }
    })
    return
  }
  next()
})

export default router
